export const softEditorialEase = [0.22, 0.55, 0.28, 1] as const
export const softEditorialEaseInOut = [0.45, 0, 0.2, 1] as const

export const softMotionDuration = {
  page: 0.54,
  panel: 0.58,
  handoff: 0.78,
  reveal: 1.02,
  revealEmphasis: 1.16,
} as const
